import WyblInfo from '@/views/purchase/WyblInfo'
import DelPrcsPrgs from '@/views/purchase/DelPrcsPrgs'
import IndvInfoPrcsPrts from '@/views/purchase/IndvInfoPrcsPrts'
import SaleAgrm from '@/views/purchase/SaleAgrm'
import TalkDeposit from '@/views/purchase/sale/TalkDeposit.vue'
import TalkDepositNew from '@/views/purchase/sale/TalkDeposit_new.vue'
import CouponGuide from '@/views/purchase/CouponGuide.vue'
import NonfunctionalNotice from '@/views/purchase/sale/nonfunctional/Notice.vue'
import SaleCncl from '@/views/purchase/SaleCncl'
import DonateApply from '@/views/purchase/DonateApply'
import DonateDetail from '@/views/purchase/DonateDetail'
import DonateDetailData from '@/views/purchase/DonateDetailData'
import DonateComplete from '@/views/purchase/DonateComplete'
import PcPhtgUpld from '@/views/purchase/PcPhtgUpld'
import TabletPhtgUpld from '@/views/purchase/TabletPhtgUpld'
import WatchPhtgUpld from '@/views/purchase/WatchPhtgUpld'
import BudsPhtgUpld from '@/views/purchase/BudsPhtgUpld'
import EupReturCncl from '@/views/purchase/EupReturCncl'
import EupReturAftrRepr from '@/views/purchase/EupReturAftrRepr'
import EupReqAgree from '@/views/purchase/EupReqAgree'
import EupReqHold from '@/views/purchase/EupReqHold'
import saleCnclComplete from '@/views/purchase/saleCnclComplete'
import delCert from '@/views/purchase/delCert'
import VisitMintit from '@/views/purchase/home/VisitMintit'
import VisitMintitComplete from '@/views/purchase/home/VisitMintitComplete'
import MintitHomeRslt from '@/views/purchase/home/MintitHomeRslt'
import MintitHomeDeposit from '@/views/purchase/home/MintitHomeDeposit.vue'
import MintitHomeCncl from '@/views/purchase/home/MintitHomeCncl'

export default [
	{
    path: '/purchase/delCert',
    name: 'delCert',
    component: delCert,
    meta: {
      authRequired: false,
      desc: 'Data 삭제인증서'
    }
  },
  {
    path: '/purchase/saleCnclComplete',
    name: 'saleCnclComplete',
    component: saleCnclComplete,
    meta: {
      authRequired: false,
      desc: '판매 취소 접수'
    }
  },
  {
    path: '/purchase/WyblInfo',
    name: 'WyblInfo',
    component: WyblInfo,
    meta: {
      authRequired: false,
      desc: '운송장정보'
    }
  },
  {
    path: '/purchase/DelPrcsPrgs',
    name: 'DelPrcsPrgs',
    component: DelPrcsPrgs,
    meta: {
      authRequired: false,
      desc: '삭제처리진행'
    }
  },
  {
    path: '/purchase/IndvInfoPrcsPrts',
    name: 'IndvInfoPrcsPrts',
    component: IndvInfoPrcsPrts,
    meta: {
      authRequired: false,
      desc: '개인정보수집 처리내역'
    }
  },
  {
    path: '/purchase/SaleAgrm',
    name: 'SaleAgrm',
    component: SaleAgrm,
    meta: {
      authRequired: false,
      desc: '판매동의'
    }
  },
  {
    path: '/purchase/sale/talkDeposit',
    name: 'TalkDeposit',
    component: TalkDeposit,
    meta: {
      authRequired: false,
      desc: '입금정보입력'
    }
  },
  {
    path: '/purchase/sale/talkDeposit_new',
    name: 'TalkDepositNew',
    component: TalkDepositNew,
    meta: {
      authRequired: false,
      desc: '입금정보입력'
    }
  },
  {
    path: '/purchase/CouponGuide',
    name: 'CouponGuide',
    component: CouponGuide,
    meta: {
      authRequired: false,
      desc: '쿠폰 사용 안내'
    }
  },
  {
    path: '/purchase/sale/nonfunctional/notice',
    name: 'NonfunctionalNotice',
    component: NonfunctionalNotice,
    meta: {
      authRequired: false,
      desc: '커넥터 미설치단말 안내'
    }
  },
  {
    path: '/purchase/SaleCncl',
    name: 'SaleCncl',
    component: SaleCncl,
    meta: {
      authRequired: false,
      desc: '판매취소'
    }
  },
  {
    path: '/purchase/donateApply',
    name: 'donateApply',
    component: DonateApply,
    meta: {
      authRequired: false,
      desc: '기부 신청서'
    }
  },
  {
    path: '/purchase/donateDetail',
    name: 'donateDetail',
    component: DonateDetail,
    meta: {
      authRequired: false,
      desc: '기부 내역'
    }
  },
  {
    path: '/purchase/donateDetailData',
    name: 'donateDetailData',
    component: DonateDetailData,
    meta: {
      authRequired: false,
      desc: '민팃 기부 내역'
    }
  },
  {
    path: '/purchase/donateComplete',
    name: 'donateComplete',
    component: DonateComplete,
    meta: {
      authRequired: false,
      desc: '기부 신청 완료'
    }
  },
  {
    path: '/purchase/PcPhtgUpld',
    name: 'PcPhtgUpld',
    component: PcPhtgUpld,
    meta: {
      authRequired: false,
      desc: 'PC사진업로드'
    }
  },
  {
    path: '/purchase/TabletPhtgUpld',
    name: 'TabletPhtgUpld',
    component: TabletPhtgUpld,
    meta: {
      authRequired: false,
      desc: '태블릿사진업로드'
    }
  },
  {
    path: '/purchase/WatchPhtgUpld',
    name: 'WatchPhtgUpld',
    component: WatchPhtgUpld,
    meta: {
      authRequired: false,
      desc: '워치사진업로드'
    }
  },
  {
    path: '/purchase/BudsPhtgUpld',
    name: 'BudsPhtgUpld',
    component: BudsPhtgUpld,
    meta: {
      authRequired: false,
      desc: '버즈사진업로드'
    }
  },
  {
    path: '/purchase/EupReturCncl',
    name: 'EupReturCncl',
    component: EupReturCncl,
    meta: {
      authRequired: false,
      desc: '클립기변부적합-반납 취소'
    }
  },
  {
    path: '/purchase/EupReturAftrRepr',
    name: 'EupReturAftrRepr',
    component: EupReturAftrRepr,
    meta: {
      authRequired: false,
      desc: '클립기변부적합-수리 후 반송'
    }
  },
  {
	    path: '/purchase/EupReqAgree',
	    name: 'EupReqAgree',
	    component: EupReqAgree,
	    meta: {
	      authRequired: false,
	      desc: 'EUP청구요청 처리'
	    }
  },
  {
	    path: '/purchase/EupReqHold',
	    name: 'EupReqHold',
	    component: EupReqHold,
	    meta: {
	      authRequired: false,
	      desc: 'EUP청구보류 처리'
    }
  },
  {
    path: '/purchase/VisitMintit',
    name: 'VisitMintit',
    component: VisitMintit,
    meta: {
      authRequired: false,
      desc: '민팃 Home'
    }
  },
  {
    path: '/purchase/VisitMintitComplete',
    name: 'VisitMintitComplete',
    component: VisitMintitComplete,
    meta: {
      authRequired: false,
      desc: '민팃 Home - 픽업 신청 완료'
    }
  },
  {
    path: '/purchase/home/rslt',
    name: 'MintitHomeRslt',
    component: MintitHomeRslt,
    meta: {
      authRequired: false,
      desc: '민팃 Home - 결과'
    }
  },
  {
    path: '/purchase/home/dpst',
    name: 'MintitHomeDeposit',
    component: MintitHomeDeposit,
    meta: {
      authRequired: false,
      desc: '민팃 Home - 입금정보입력'
    }
  },
  {
    path: '/purchase/home/cncl',
    name: 'MintitHomeCncl',
    component: MintitHomeCncl,
    meta: {
      authRequired: false,
      desc: '민팃 Home - 신청취소'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/purchase/index.js